import axios from "axios";
import Globals from "../api/globals";
import {
  formatDateToMM,
  formatDateToYYYY,
  formatDateToYYYYMM,
  formatDateToYYYYMMDD,
} from "../functions/date-format";
import SectorModel from "../models/sector.model";

export default class SectorService {
  private static _instance: SectorService | null = null;

  private constructor() {}

  static getInstance(): SectorService {
    if (!SectorService._instance) {
      SectorService._instance = new SectorService();
    }
    return SectorService._instance;
  }

  async getAllSectors(userId: number): Promise<SectorModel[]> {
    const token = localStorage.getItem("token");
    const result: SectorModel[] = [];
    let page = 1;

    while (true) {
      const response = await axios.get(
        `${Globals.apiUrl}/sectors?filters[user][id][$eq]=${userId}&pagination[page]=${page}&pagination[pageSize]=100`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200 && response.data.data.length > 0) {
        response.data.data.forEach((sector: any) => {
          result.push(SectorModel.fromJson(sector));
        });
      }

      if (response.data.data.length === 0) break;

      page++;
    }

    return result;
  }
}
